<div class="referrals-modal">
    <button (click)="activeModal.dismiss('Cross click')" class="referrals-modal-close" type="button" aria-label="Cerrar"></button>
    <app-referral-panel [tenantId]="tenantId" analyticsSource="sidenav"></app-referral-panel>
</div>
